import { Search } from "@mui/icons-material";
import { Box, Button, MenuItem, TextField } from "@mui/material";
import { useState } from "react";

const months = [
    { label: "January", value: "January" },
    { label: "February", value: "February" },
    { label: "March", value: "March" },
    { label: "April", value: "April" },
    { label: "May", value: "May" },
    { label: "June", value: "June" },
    { label: "July", value: "July" },
    { label: "August", value: "August" },
    { label: "September", value: "September" },
    { label: "October", value: "October" },
    { label: "November", value: "November" },
    { label: "December", value: "December" }
];
const SelectMonthYear = ({ onSuccess }) => {

    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().toLocaleString('en-US', { month: 'long' });

    const [month, setMonth] = useState(currentMonth);
    const [year, setYear] = useState(currentYear);

    const years = Array.from({ length: 3 }, (_, i) => currentYear - i);

    const salarySlip = () => {
        onSuccess(month, year);
    };

    return (
        <Box>
            <Box display="flex" justifyContent={'center'} gap={2} mb={2}>
                <TextField
                    select
                    size="small"
                    label="Month"
                    value={month}
                    onChange={e => setMonth(e.target.value)}
                >
                    {months.map(m => (
                        <MenuItem key={m.value} value={m.value}>
                            {m.label}
                        </MenuItem>
                    ))}
                </TextField>

                <TextField
                    select
                    label="Year"
                    size="small"
                    value={year}
                    onChange={e => setYear(Number(e.target.value))}
                >
                    {years.map(y => (
                        <MenuItem key={y} value={y}>
                            {y}
                        </MenuItem>
                    ))}
                </TextField>
                <Button onClick={() => salarySlip()}><Search /></Button>
            </Box>
        </Box>
    );
};
export default SelectMonthYear;